"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _eventhub = _interopRequireDefault(require("../lib/eventhub"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = {
  beforeMount: function beforeMount() {
    // Listeners
    _eventhub["default"].on("core:errors:handle", this.__handleError);

    _eventhub["default"].on("core:errors:clear", this.__clearError);
  },
  beforeDestroy: function beforeDestroy() {
    // Remove listeners
    _eventhub["default"].off("core:errors:handle", this.__handleError);

    _eventhub["default"].off("core:errors:clear", this.__clearError);
  },
  methods: {
    __clearError: function __clearError() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (typeof this.clearError !== 'function') {
        console.warn('[UI - Error handling]', 'Please add a \'clearError\' method when using the errorUIMixin');
        return;
      }

      this.clearError(options);
    },
    __handleError: function __handleError(error) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (typeof this.handleError !== 'function') {
        console.warn('[UI - Error handling]', 'Please add a \'handleError\' method when using the errorUIMixin');
        return;
      }

      this.handleError(error, options);
    }
  }
};
exports["default"] = _default;